import Joyride from 'react-joyride';
import CustomBeacon from './CustomBeacon';
import { useSelector } from 'react-redux';
import './Tour.css';

function Tour({ steps, run, cbHandleJoyride = () => {}, isContinuos = true }) {
	const isFirstTimeUser = useSelector((state) => state.tourReducer.isFirstTimeUser);

	function getRunStatus() {
		if (!isFirstTimeUser) {
			return false;
		}
		return run;
	}

	return (
		<Joyride
			steps={steps}
			styles={{
				options: {
					arrowColor: '#3A1D93',
					backgroundColor: '#3A1D93',
					textColor: '#FFFFFF',
					zIndex: 2000,
					fontSize: 16,
					spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)'
				}
			}}
			run={getRunStatus()}
			showSkipButton={true}
			disableOverlay={true}
			beaconComponent={CustomBeacon}
			callback={cbHandleJoyride}
			hideBackButton={true}
			continuous={isContinuos}
			disableScrolling
		/>
	);
}

export default Tour;
